import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LeakAddIcon(props: IconProps) {
    return <Icon {...props} iconKey={"leak_add"}/>
}
